import { ALERT_TYPES, type AlertType } from '../dataProvider';

/**
 * Admin-side helpers for the internal-alerts surface (D-internal-alerts, Phase 9), the last
 * feature surface. The CONFIG half (per-type rows, region-keyed monetary thresholds) and the
 * read-only fired-alert TRAIL. The alert-type set is the LOCKED documented four; the monetary
 * types are region-keyed, the rest are global.
 */

/** Display label for an alert type. */
export const ALERT_TYPE_LABEL: Record<AlertType, string> = {
  high_value_cashout: 'High value cashout',
  large_refund: 'Large refund',
  suspicious_activity: 'Suspicious activity',
  system_error: 'System error',
};

/** The trail facet choices (the locked type set as fixed SelectInput choices). */
export const ALERT_TYPE_CHOICES = ALERT_TYPES.map((t) => ({
  id: t,
  name: ALERT_TYPE_LABEL[t],
}));

/** The monetary (region-keyed) alert types: they fire above a per-market amount. */
export const MONETARY_ALERT_TYPES: readonly AlertType[] = [
  'high_value_cashout',
  'large_refund',
];

/** Whether an alert type carries a per-market monetary threshold (region-keyed). */
export const isMonetaryAlert = (type: AlertType): boolean =>
  MONETARY_ALERT_TYPES.includes(type);

/** The label for a type, falling back to the raw key. */
export const alertTypeLabel = (type: string): string =>
  ALERT_TYPE_LABEL[type as AlertType] ?? type;
